import CancelIcon from "@mui/icons-material/CancelRounded";
import CheckIcon from "@mui/icons-material/CheckCircleRounded";
import SkippedIcon from "@mui/icons-material/RemoveCircleRounded";
import { Box, Button, Link, Paper, Stack, Typography } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { WorkflowProgressActionResult, WorkflowProgressEntry } from "../../../../../api/types/workflowTypes";

interface Props {
  entries: WorkflowProgressEntry[];
  onSelectActivity: (activityId: string) => void;
}

const ActionResultIcon = ({ actionResult }: { actionResult: WorkflowProgressActionResult }) => {
  switch (actionResult) {
    case "Success":
      return <CheckIcon color="success" />;
    case "Failed":
      return <CancelIcon color="error" />;
    case "Skipped":
      return <SkippedIcon color="disabled" />;
    default:
      return null;
  }
};

const WorkflowSummaryDetailContent = ({ entries, onSelectActivity }: Props) => {
  return (
    <ScrollableFlexContainer>
      <Stack spacing={1} sx={{ px: 3, py: 2.5 }}>
        {entries.map((entry) => (
          <Paper key={entry.id} variant="outlined">
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 1.5, py: 1 }}>
              <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
                <ActionResultIcon actionResult={entry.actionResult} />
                <Stack spacing={0.25}>
                  <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
                    <Typography variant="subtitle2">{entry.actionDescription}</Typography>
                    {entry.workflowActivityId && (
                      <Button
                        variant="text"
                        color="primary"
                        onClick={() => onSelectActivity(entry.workflowActivityId ?? "")}
                      >
                        Go to activity
                      </Button>
                    )}
                  </Stack>
                  <Typography color="textSecondary">{entry.actionTarget}</Typography>
                </Stack>
              </Stack>

              {entry.openUrl && (
                <Button
                  variant="outlined"
                  color="primary"
                  component={Link}
                  href={entry.openUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open
                </Button>
              )}
            </Box>
          </Paper>
        ))}
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default WorkflowSummaryDetailContent;
